"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../../../../theme/icons");
const global_1 = require("../../../global");
const ContextMenu_styles_1 = require("./ContextMenu.styles");
const ContextMenu = ({ actionHandler, items, showShortcuts, stayOpen, hideSubMenuOnClose, }) => {
    const [openSubMenu, setOpenSubMenu] = (0, react_1.useState)(false);
    const [openItemIndex, setOpenItemIndex] = (0, react_1.useState)();
    const openMenu = (index) => {
        setOpenSubMenu(true);
        setOpenItemIndex(index);
    };
    (0, react_1.useEffect)(() => {
        if (hideSubMenuOnClose) {
            setOpenSubMenu(false);
        }
    }, [hideSubMenuOnClose]);
    return (react_1.default.createElement(ContextMenu_styles_1.MenuWrapper, null,
        react_1.default.createElement(ContextMenu_styles_1.MenuContentWrapper, null, items.map((item, index) => {
            var _a;
            const Icon = item.icon;
            return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                items.length > 1 && index === items.length - 1 && react_1.default.createElement(ContextMenu_styles_1.HorizontalLine, null),
                items.length > 2 && index === items.length - 2 && react_1.default.createElement(ContextMenu_styles_1.HorizontalLine, null),
                react_1.default.createElement(ContextMenu_styles_1.MenuItemWrapper, { onClick: () => {
                        if (!stayOpen) {
                            if (!item.subItems) {
                                actionHandler(item.action);
                            }
                        }
                        else {
                            actionHandler(item.action);
                        }
                    }, onMouseEnter: () => {
                        openMenu(index);
                    }, onMouseLeave: () => {
                        if (!stayOpen) {
                            setOpenSubMenu(false);
                        }
                    } },
                    react_1.default.createElement(ContextMenu_styles_1.Item, null,
                        react_1.default.createElement(global_1.IconWrapper, { width: 18, height: 18, hoverEffect: false },
                            react_1.default.createElement(Icon, null)),
                        react_1.default.createElement(ContextMenu_styles_1.LabelWrapper, null, item.label)),
                    item.subItems ? (react_1.default.createElement(ContextMenu_styles_1.ExtendIconDiv, null,
                        react_1.default.createElement(icons_1.ArrowRight, null),
                        openSubMenu && item.subItems && openItemIndex === index && (react_1.default.createElement(ContextMenu_styles_1.SubMenuWrapper, null,
                            react_1.default.createElement(ContextMenu_styles_1.MenuContentWrapper, null, (_a = item.subItems) === null || _a === void 0 ? void 0 : _a.map((ele, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index },
                                react_1.default.createElement(ContextMenu_styles_1.MenuItemWrapper, { onClick: () => {
                                        actionHandler(ele.action);
                                    } },
                                    react_1.default.createElement(ContextMenu_styles_1.LabelWrapper, null, ele.label),
                                    showShortcuts && react_1.default.createElement(ContextMenu_styles_1.Shortcut, null, ele.label.charAt(0))))))))))) : (showShortcuts && react_1.default.createElement(ContextMenu_styles_1.Shortcut, null, item.label.charAt(0))))));
        }))));
};
exports.ContextMenu = ContextMenu;
//# sourceMappingURL=ContextMenu.js.map